import { install } from 'offline-plugin/runtime'
if (process.env.NODE_ENV === 'production') install()
import 'isomorphic-fetch'
import 'styles/sparkles'

import {crel, div, text} from 'teact'
import {render} from 'react-dom'
import {Modal} from 'components/modal'

document.addEventListener('DOMContentLoaded', ->
  root = document.createElement('div')
  document.body?.appendChild(root)
  render(crel(Modal, { show: 'true' }, ->
    div('.test', text('Hi there, this is a modal!'))
  ), root)
)

square(n: number): number -> n * n
square('2')



// WEBPACK FOOTER //
// ./src/sparkles.lsc